'use strict';

require("core-js/modules/es6.array.index-of");

module.exports = locate;

function locate(value, fromIndex) {
  return value.indexOf('\\', fromIndex);
}